import React from 'react';
import { DEAL_CONTACT_ROLE_ORDER, getDealContactRoleLabel } from '@vanilla/constants/DealContactRoles.js';
import { Button } from '@/components/ui/button';
import { NativeCheckbox } from '@/components/ui/checkbox';
import { X } from 'lucide-react';
import { DealFormSelect } from './DealFormSelect.jsx';
import { contactDisplayName } from './dealFormUtils.js';

export default function DealFormContactsPanel({
    form,
    contacts,
    addContactRole,
    updateContactRole,
    removeContactRole,
}) {
    const firstName = contactDisplayName;
    return (
        <div className="premium-card" id="sectionContactsCard" data-stepper-panel="contacts">
            <div className="premium-card-header">
                <h3 className="premium-card-title"><span className="premium-card-number">3</span> Contacts</h3>
                <p className="premium-card-subtitle">Buying committee — assign a role to each contact on this deal. Deal primary does not change the account SPOC.</p>
            </div>
            <div id="dealContactsContent">
                <div className="deal-contact-roles-section" style={{ borderTop: 'none', marginTop: 0 }} data-field="dealContactRoles">
                    {!form.dealClientId ? (
                        <p className="field-hint">Select an account to load its contacts.</p>
                    ) : contacts.length === 0 ? (
                        <p className="field-hint">No contacts found for this account.</p>
                    ) : null}
                    <div className="grid gap-3" id="dealContactRoleRows" style={{ gridTemplateColumns: 'repeat(1, minmax(0, 1fr))' }}>
                        {(form.contactRoles || []).map((row, i) => (
                            <div key={i} className="deal-contact-role-row grid" style={{ gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr) 36px', gap: '12px', alignItems: 'start' }}>
                                <div className="form-group flex flex-col gap-1.5" style={{ margin: 0 }}>
                                    <DealFormSelect
                                        value={row.contactId}
                                        placeholder="Select contact"
                                        onValueChange={(v) => updateContactRole(i, { contactId: v })}
                                        options={contacts.map((c) => ({ value: c.id, label: firstName(c) }))}
                                    />
                                    <label className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground cursor-pointer select-none">
                                        <NativeCheckbox unstyled checked={!!row.isPrimary} onChange={(e) => updateContactRole(i, { isPrimary: e.target.checked })} /> Primary
                                    </label>
                                </div>
                                <div className="form-group" style={{ margin: 0 }}>
                                    <DealFormSelect
                                        value={row.role}
                                        allowEmpty={false}
                                        onValueChange={(v) => updateContactRole(i, { role: v })}
                                        options={DEAL_CONTACT_ROLE_ORDER.map((r) => ({ value: r, label: getDealContactRoleLabel(r) }))}
                                    />
                                </div>
                                <button type="button" aria-label="Remove contact" onClick={() => removeContactRole(i)} className="inline-flex items-center justify-center size-9 rounded-md border border-transparent text-muted-foreground hover:text-destructive hover:bg-destructive/10 hover:border-destructive/20 transition-colors shrink-0 self-start mt-0.5">
                                    <X className="size-4" />
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className="contact-role-actions recipients-header-actions" style={{ marginTop: 8, justifyContent: 'flex-end' }}>
                        <Button type="button" className="btn btn-secondary btn-sm" variant="secondary" size="sm" id="dealAddContactRoleBtn" disabled={!form.dealClientId} onClick={addContactRole}>+ Add contact role</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
